import { api } from './client';

/** Папки чатов — см. ChatFolderService. Чат может быть в нескольких папках. */
export interface ChatFolderDto {
  id: string;
  name: string;
  chatIds: string[];
}

export function listFolders(): Promise<ChatFolderDto[]> {
  return api('/api/v1/folders');
}

export function createFolder(name: string): Promise<ChatFolderDto> {
  return api('/api/v1/folders', { method: 'POST', body: JSON.stringify({ name }) });
}

export function renameFolder(id: string, name: string): Promise<ChatFolderDto> {
  return api(`/api/v1/folders/${id}`, { method: 'PUT', body: JSON.stringify({ name }) });
}

export function deleteFolder(id: string) {
  return api(`/api/v1/folders/${id}`, { method: 'DELETE' });
}

export function addChatToFolder(folderId: string, chatId: string) {
  return api(`/api/v1/folders/${folderId}/chats/${chatId}`, { method: 'PUT' });
}

export function removeChatFromFolder(folderId: string, chatId: string) {
  return api(`/api/v1/folders/${folderId}/chats/${chatId}`, { method: 'DELETE' });
}

/** Смарт-папки вкл/выкл + порядок табов (см. lib/smartFolders.ts) — раньше жили в localStorage
 *  клиента, не синхронизировались между устройствами (см. отчёт пользователя "перенеси в базу
 *  папки"). */
export interface FolderPrefsDto {
  enabledSmart: string[];
  folderOrder: string[];
}

export function getFolderPrefs(): Promise<FolderPrefsDto> {
  return api('/api/v1/folders/prefs');
}

/** Частичный апдейт — не переданное поле не трогается на сервере. */
export function updateFolderPrefs(patch: { enabledSmart?: string[]; folderOrder?: string[] }): Promise<FolderPrefsDto> {
  return api('/api/v1/folders/prefs', { method: 'PUT', body: JSON.stringify(patch) });
}
